import { LocationOn, ShoppingCart } from '@mui/icons-material';
import {
  Badge,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { navigateToAddStpDetails } from '../BCMOrder/functions';

function CartAndAddressComponent({ hideDeliveryDetails = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { addedUserList, selectedStp } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      selectedStp: state.bcmOrderReducer.selectedStp,
    };
  });

  const setUser = (data) => {
    if (addedUserList.length === 0) {
      return toast.error('Please add delivery details to add products to cart');
    } else {
      navigate('/order-booking/selected-ship-to-party-list', {
        state: {
          isComingFromPdp: true,
        },
      });
    }
  };

  return (
    <Stack direction={'row'}>
      {!hideDeliveryDetails && (
        <>
          {!addedUserList || addedUserList.length === 0 ? (
            <>
              <Button
                variant='text'
                startIcon={<LocationOn fontSize='large' />}
                sx={{
                  color: '#000000',
                  width: '70%',
                }}
                onClick={() => {
                  navigateToAddStpDetails({
                    dispatch,
                    navigate,
                  });
                }}
              >
                Add ship to party
              </Button>
            </>
          ) : (
            <Button
              variant='text'
              startIcon={<LocationOn fontSize='large' />}
              sx={{
                color: '#F99D1C',
                width: '70%',
              }}
              onClick={() => {
                navigateToAddStpDetails({
                  dispatch,
                  navigate,
                });
              }}
            >
              <Tooltip title={selectedStp?.company_name}>
                <Typography
                  variant='subtitle2'
                  noWrap
                  style={{
                    maxWidth: '180px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: '#F99D1C',
                  }}
                >
                  {selectedStp?.company_name}
                </Typography>
              </Tooltip>
            </Button>
          )}

          <Badge
            badgeContent={selectedStp?.products?.length || null}
            color='primary'
          >
            <IconButton
              onClick={() => {
                setUser();
              }}
            >
              <ShoppingCart
                sx={{
                  fontSize: 40,
                  color: '#000000',
                }}
              />
            </IconButton>
          </Badge>
        </>
      )}
    </Stack>
  );
}

export default CartAndAddressComponent;
